import React, { useState } from "react";
import GlobalState from "../../useGlobalState";
import Recursive from "../../Recursive";
import { useMemo } from "react";
function PreviewPanel() {
  const { state, dispatch } = GlobalState.useContainer();
  const onClickHandler = (id) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch({
      type: "CHANGE_TREE_SEARCH_TERM",
      payload: {
        searchTerm: id,
      },
    });
  };
  return useMemo(
    () => (
      <div className="w-full flex flex-col justify-between border-2 relative">
        <div className="flex-grow overflow-auto">
          {state.treeData.map((branch) => {
            
            return (
              <Recursive
                {...branch}
                babies={branch.children}
                key={branch.id}
                allTreeAttritbutes={state.attributes}
                onClickHandler={onClickHandler}
              />
            );
          })}
        </div>
        <div className="p-1 absolute bottom-0 right-0 opacity-25 hover:opacity-100">
          <a target="_black" href="/preview">
            Open Preview in New Window
          </a>
        </div>
      </div>
    ),
    [state.treeData, state.attributes]
  );
}

export default PreviewPanel;
